const state = {
  isRegistered: false, //通道注册状态
  iscalling: false, //是否通话中
  isincall: false, //是否呼入
  currentSip: null, //当前sip
  isAnswer: false, //是否接听
  isVirtualNumber: false, //是否虚拟号码
  virtualNumber: '', //虚拟号码
}

const mutations = {
  SET_IS_REGISTERED: (state, isRegistered) => {
    state.isRegistered = isRegistered
  },
  SET_IS_CALLING: (state, iscalling) => {
    state.iscalling = iscalling
  },
  SET_IS_IN_CALL: (state, isincall) => {
    state.isincall = isincall
  },
  SET_CURRENT_SIP: (state, currentSip) => {
    state.currentSip = currentSip
  },
  SET_IS_ANSWER: (state, isAnswer) => {
    state.isAnswer = isAnswer
  },
  SET_IS_VIRTUAL_NUMBER: (state, isVirtualNumber) => {
    state.isVirtualNumber = isVirtualNumber
  },
  SET_VIRTUAL_NUMBER: (state, virtualNumber) => {
    state.virtualNumber = virtualNumber
  },
}

const actions = {
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/webrtc.js